import { useSelector, TypedUseSelectorHook } from 'react-redux';

import { IStore } from 'config/reducers';

export const useTypedSelector: TypedUseSelectorHook<IStore> = useSelector;
